import { useMedia } from 'tamagui'

export default function useIsMobile() {
  const media = useMedia()
  return media.mobile
}
